import { motion } from "framer-motion";
import { Coffee, Leaf, Palmtree, Wheat, Citrus } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const CROPS = [
  { icon: Coffee, name: "Coffee", testid: "grow-card-coffee", line: "Shade-grown arabica and robusta, slow-ripened under native trees." },
  { icon: Leaf, name: "Pepper", testid: "grow-card-pepper", line: "Black pepper, trailed up silver oak and jungle shade." },
  { icon: Palmtree, name: "Arecanut", testid: "grow-card-arecanut", line: "Tall palms, harvested by hand through the year." },
  { icon: Wheat, name: "Paddy", testid: "grow-card-paddy", line: "Terraced fields, fed by monsoon streams." },
  { icon: Citrus, name: "Citrus Fruits", testid: "grow-card-citrus", line: "Oranges and lemons from the estate's old orchards." },
];

const Grow = () => (
  <section id="grow" data-testid="what-we-grow-section" className="py-24 sm:py-32 lg:py-40 bg-paper">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="max-w-2xl"
      >
        <p className="eyebrow mb-6">What We Grow</p>
        <h2 className="font-display font-normal text-espresso text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          Five crops. One canopy.
          <span className="italic text-forest"> Countless seasons.</span>
        </h2>
      </motion.div>

      <div className="mt-14 sm:mt-20 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {CROPS.map((crop, i) => (
          <motion.article
            key={crop.name}
            data-testid={crop.testid}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.09, ease: EASE }}
            className="group bg-cream border border-coffee-soft rounded-sm p-7 sm:p-8 hover:-translate-y-2 hover:shadow-xl hover:shadow-espresso/10 hover:border-gold/50 transition-all duration-500"
          >
            <div className="w-12 h-12 rounded-full bg-forest flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-espresso transition-colors duration-500">
              <crop.icon size={20} strokeWidth={1.5} aria-hidden="true" />
            </div>
            <h3 className="mt-6 font-display text-xl sm:text-2xl font-medium text-espresso">{crop.name}</h3>
            <p className="mt-3 text-sm leading-relaxed text-muted-brand">{crop.line}</p>
          </motion.article>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.5 }}
        className="mt-12 text-center font-display italic text-lg text-coffee/70"
      >
        — and many more, as the seasons allow.
      </motion.p>
    </div>
  </section>
);

export default Grow;
